import { useEffect, useState } from "react";
import { Plus } from "lucide-react";

export function Navbar({ onAdd, onBrowse }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 12);
    fn();
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-paper/85 backdrop-blur-md border-b border-hairline"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-8">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            onBrowse("#top");
          }}
          data-testid="nav-logo"
          className="flex items-center gap-2.5"
        >
          <img
            src="/logo.png"
            alt="Systech Aqua Solutions logo"
            className="h-8 w-8 object-contain"
          />
          <span className="font-display text-[13px] font-extrabold tracking-[-0.01em] text-ink sm:text-lg">
            SYSTECH AQUA SOLUTIONS
          </span>
        </a>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-browse-button"
            onClick={() => onBrowse("#deck")}
            className="hidden sm:inline-flex items-center px-4 py-2.5 font-mono text-[11px] tracking-[0.2em] text-ink/70 transition-colors duration-300 hover:text-ink"
          >
            BROWSE DECK
          </button>
          <button
            data-testid="nav-add-card-button"
            onClick={onAdd}
            className="inline-flex items-center gap-2 bg-ink px-4 py-2.5 font-mono text-[11px] tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-signal"
          >
            <Plus className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">ADD DASHBOARD</span>
            <span className="sm:hidden">ADD</span>
          </button>
        </div>
      </div>
    </header>
  );
}
